import { render, staticRenderFns } from "./PreviewField.vue?vue&type=template&id=10c71dd0&scoped=true"
import script from "./PreviewField.vue?vue&type=script&lang=js"
export * from "./PreviewField.vue?vue&type=script&lang=js"
import style0 from "./PreviewField.vue?vue&type=style&index=0&id=10c71dd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c71dd0",
  null
  
)

export default component.exports